import { createSelector } from '@ngrx/store';
import { selectCtdState } from '../reducers';
import * as fromCtdOrder from '../reducers/ctd-order.reducer';

export const selectCtdOrders = createSelector(selectCtdState, fromCtdOrder.selectAll);
export const selectCtdOrderIds = createSelector(selectCtdState, fromCtdOrder.selectIds);
export const selectCtdOrderEntities = createSelector(selectCtdState, fromCtdOrder.selectEntities);
export const selectCtdOrderTotal = createSelector(selectCtdState, fromCtdOrder.selectTotal);

export const selectCtdOrderById = createSelector(
  selectCtdOrderEntities,
  (ctdOrderEntities, { id }) => ctdOrderEntities[id],
);

export const selectCurrentEntityId = createSelector(selectCtdState, fromCtdOrder.selectSelectedEntityId);

export const selectSelectedEntity = createSelector(
  selectCtdOrderEntities,
  selectCurrentEntityId,
  (ctdOrderEntities, id) => id && ctdOrderEntities[id],
);
